import { CaretRightOutlined, RightOutlined } from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Steps,
    Button,
    message,
    Form,
    Input,
    Image,
    Carousel,
    Card,
    Divider,
    Select,
    DatePicker,
    Radio,
    Checkbox,
    Space,
    Avatar,
    Spin,
    Tag
} from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


import { ADD_MODE, DATE_FORMAT_DMY_SLASH, EDIT_MODE, ROUND_OFF_ACCOUNT_ID, SAVE_SUCCESS_MSG, SUCCESS_STATUS, UPDATE_SUCCESS_MSG } from "../../utility/Constants";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";

import moment from "moment";
import commonUtility from "../../utility/Utils";
// import AccountDrCrDetails from "../accountdetails/AccountDrCrDetails";
import accountService from "../../api/account.service";
import PurchaseDetailView from "./PurchaseDetailView";
import Meta from "antd/lib/card/Meta";
import purchaseService from "../../api/purchase.service";

const { Option } = Select;
const { TextArea } = Input;

const dividerStyle = {
    margin:'4px 0'
}

const defaultFormValues = {
    purchase_id: 0,
    bill_number: "",
    bill_date: "",
    mode: "ADD",
    vendor_id: "",
    voucher_id: 0,
    dr_ac_id: "",
    total_taxable: 0,
    total_cgst: 0,
    total_sgst: 0,
    total_igst: 0,
    total_gst: 0,
    gst_including_amount: 0,
    round_off_amount: 0,
    round_off_account_id: ROUND_OFF_ACCOUNT_ID,
    net_amount: 0,
    purchase_details: []
};




const PurchaseEntryView = () => {

    const [accountList, setAccountList] = useState([]);
    const [vendorList, setVendorList] = useState([]);


    const [form] = Form.useForm();
    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");
    const [formErrorMessage, setFormErrorMessage] = useState("");
    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [summaryAmountDetails, setSummaryAmountDetails] = useState({
        totalAmount:0,
        totalCGST:0,
        totalSGST:0,
        totalIGST:0,
        totalGST:0,
        totalNetAmountWithGST:0,
        round_off_amount:0,
        netAmountAfterRoundOff:0,
    });
    const [totalCreditAmount, setTotalCreditAmount] = useState(0);

    const [responseModal, setResponseModal] = useState({
        responseModalTitle: '',
        isOpenModal: false,
        listLink: '',
        addmoreLink: '',
        responseModalMessage: '',
        printReuired: false
    });


    const params = useParams();

    const onPurchaseSave = async (values) => {
                 setResponseModal({
                    responseModalTitle: '',
                    isOpenModal: false,
                    listLink: '',
                    addmoreLink: '',
                    responseModalMessage: '',
                    printReuired: false
                });


                if(values.purchase_details.length >0){
                    setSaveLoaderEnable(true)
                    const data = { formdata: values };
                    const response = purchaseService.purchaseSave(data).then((resdata) => {
                        
                        if(values.mode == ADD_MODE){
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/purchase/list',
                                addmoreLink: '/purchase/entry',
                                responseModalMessage: `${values.bill_number} saved successfully`,
                                printReuired: false
                            });
                        }
                        else if(values.mode == EDIT_MODE) {
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/purchase/list',
                                addmoreLink: '/purchase/entry',
                                responseModalMessage: `${values.bill_number} updated successfully`,
                                printReuired: false
                            });
                        }
                        setSaveLoaderEnable(false)
    
                        /*
                        if (resdata.response_data.mode == ADD_MODE) {
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/journalvoucher/list',
                                addmoreLink: '/journalvoucher/entry',
                                responseModalMessage: `${SAVE_SUCCESS_MSG} with voucher no ${resdata.response_data.voucher_no}`,
                                printReuired: false
                            });
                        }
                        else if (resdata.response_data.mode == EDIT_MODE) {
                            setResponseModal({
                                responseModalTitle: 'Success',
                                isOpenModal: true,
                                listLink: '/journalvoucher/list',
                                addmoreLink: '/journalvoucher/entry',
                                responseModalMessage: `${UPDATE_SUCCESS_MSG}`,
                                printReuired: false
                            });
                        }
                        setSaveLoaderEnable(false)
                        */
                        
                    });
                }
                else{
                    commonUtility.openNotificationWithType("error","rightBottom","Error","Please add atleast one purchase detail.");
                    setSaveLoaderEnable(false)
                }

               
            
        
        
    };

    const handleCancel = () => {
        setOpenModal(false);
    };



  


    const onDateChange = (date, dateString) => {
        form.setFieldsValue({
            bill_date: dateString,
        });
    };



    useEffect(() => {
        accountService.accountList().then((res) => {
          setAccountList(res.data.response_data);
        });
      }, []);


      

      useEffect(() => {
        accountService.vendorList().then((res) => {
            setVendorList(res.response_data);
        });
      }, []);





    useEffect(()=>{
        
        //Purchase Edit
        if (params.purchase_id && params.purchase_id > 0) {
            const data = {
                formdata: {
                    purchase_master_id: params.purchase_id,
                },
            };


            const response = purchaseService.purchaseGetByID(data).then((resdata) => {

                if (resdata.data.response_status === SUCCESS_STATUS) {
                    console.log('resdata',resdata.data.response_data[0]);

                    let purchase_data = resdata.data.response_data[0];
                    let purchaseMasterData = purchase_data.masterData;

                    console.log('purchaseMasterData',purchaseMasterData);


                    form.setFieldsValue({  
                        purchase_id: purchaseMasterData.purchase_id,
                        bill_number: purchaseMasterData.bill_number,
                        bill_date: purchaseMasterData.bill_date,
                        bill_date_picker: purchaseMasterData.bill_date ? moment(purchaseMasterData.bill_date, DATE_FORMAT_DMY_SLASH) : '',
                        mode: "EDIT",
                        vendor_id: purchaseMasterData.vendor_id,
                        voucher_id: purchaseMasterData.voucher_master_id,
                        dr_ac_id: purchaseMasterData.dr_ac_id,
                        total_taxable: purchaseMasterData.total_taxable,
                        total_cgst: purchaseMasterData.total_cgst,
                        total_sgst: purchaseMasterData.total_sgst,
                        total_igst: purchaseMasterData.total_igst,
                        total_gst:purchaseMasterData.total_gst,
                        gst_including_amount:purchaseMasterData.gst_including_amount,
                        round_off_amount: purchaseMasterData.round_off,
                        net_amount: purchaseMasterData.net_amount,
                    });


                    // Setting Up Purchase Detail Data
                    let purchaseDetailList = purchase_data.detailsData;

                    let obj = [];
                    purchaseDetailList.map((e) => {
                        const x = {
                            particulars: e.particulars, 
                            qty: e.qty, 
                            rate: e.rate, 
                            item_value: e.item_value,  
                            cgst_id: e.cgst_id,
                            cgst_amount: e.cgst_amount,  
                            sgst_id: e.sgst_id, 
                            sgst_amount: e.sgst_amount,  
                            igst_id: e.igst_id,  
                            igst_amount: e.igst_amount, 
                            item_gst_total: e.item_gst_total,  
                            item_total_amount: e.item_total_amount, 
                        };
                        obj.push(x);
                    });
  
                    form.setFieldsValue({ purchase_details: obj });
                    onFormCalculation();
                }
                
              
            });



        }


    },[params]);
  
      


    const onFormCalculation = () => {
        setFormErrorMessage("")
            
            let purchase_details = form.getFieldValue("purchase_details");




            let total_amount_with_gst = 0;
            let total_gst = 0;
            

            // let total_amount = purchase_details.reduce((a, v) => a = a + parseFloat(v?.item_value), 0);
            // let total_cgst_amt = purchase_details.reduce((a, v) => a = a + parseFloat(v?.cgst_amount), 0);
            // let total_sgst_amt = purchase_details.reduce((a, v) => a = a + parseFloat(v?.sgst_amount), 0);
            // let total_igst_amt = purchase_details.reduce((a, v) => a = a + parseFloat(v?.igst_amount), 0);

            let total_amount = purchase_details.reduce((total, obj) => parseFloat(obj?.item_value != undefined ? obj?.item_value : 0) + total, 0);
            let total_cgst_amt = purchase_details.reduce((total, obj) => parseFloat(obj?.cgst_amount != undefined ? obj?.cgst_amount : 0) + total, 0);
            let total_sgst_amt = purchase_details.reduce((total, obj) => parseFloat(obj?.sgst_amount  != undefined ? obj?.sgst_amount : 0) + total, 0);
            let total_igst_amt = purchase_details.reduce((total, obj) => parseFloat(obj?.igst_amount  != undefined ? obj?.igst_amount : 0) + total, 0);
            

            total_gst = parseFloat(total_cgst_amt) + parseFloat(total_sgst_amt) + parseFloat(total_igst_amt);
            total_amount_with_gst = total_gst + parseFloat(total_amount);

            const payableAmountDetail = commonUtility.getRoundOfAmount(total_amount_with_gst);

           

            const payableAmt = payableAmountDetail.newPayableAmount;
            const roundoff_amount = parseFloat(payableAmountDetail.roundoffAmount);



            setSummaryAmountDetails({
                totalAmount: !isNaN(total_amount) ? total_amount : 0 ,
                totalCGST: !isNaN(total_cgst_amt) ? total_cgst_amt : 0 ,
                totalSGST: !isNaN(total_sgst_amt) ? total_sgst_amt : 0 ,
                totalIGST: !isNaN(total_igst_amt) ? total_igst_amt : 0 ,
                totalGST: !isNaN(total_gst) ? total_gst : 0,
                totalNetAmountWithGST: !isNaN(total_amount_with_gst) ? total_amount_with_gst : 0,
                round_off_amount: !isNaN(roundoff_amount) ? roundoff_amount : 0,
                netAmountAfterRoundOff: !isNaN(payableAmt) ? payableAmt : 0,
            });


            form.setFieldsValue({
                total_taxable : !isNaN(total_amount) ? total_amount : 0,
                total_cgst: !isNaN(total_cgst_amt) ? total_cgst_amt : 0,
                total_sgst: !isNaN(total_sgst_amt) ? total_sgst_amt : 0,
                total_igst: !isNaN(total_igst_amt) ? total_igst_amt : 0,
                total_gst: !isNaN(total_gst) ? total_gst : 0,
                gst_including_amount: !isNaN(total_amount_with_gst) ? total_amount_with_gst : 0,
                round_off_amount: !isNaN(roundoff_amount) ? roundoff_amount : 0,
                net_amount: !isNaN(payableAmt) ? payableAmt : 0,
            });

           
            



    }



    const removeDetail = (index) => {
        const list = [...form.getFieldValue('purchase_details')];
        list.splice(index, 1);
        form.setFieldsValue({ purchase_details: list });
        onFormCalculation();
    }




    /**
     * onQtyChange
     * @param {*} e 
     * @param {*} v 
     * @param {*} index 
     */


    const calItemAmount = (e, v, index) => {

        const qty = form.getFieldValue(["purchase_details", index, "qty",]) > 0 ? form.getFieldValue(["purchase_details", index, "qty",]) : 0;
        const rate = form.getFieldValue(["purchase_details", index, "rate",]) > 0 ? form.getFieldValue(["purchase_details", index, "rate",]) : 0;

        const amount = parseFloat(qty) * parseFloat(rate);

        form.setFields([
            {
                name: ["purchase_details", index, "item_value"],
                value: amount,
            }
        ]);


        const cgst_id = form.getFieldValue(["purchase_details", index, "cgst_id"]) != undefined ? form.getFieldValue(["purchase_details", index, "cgst_id"]) : 0;
        const sgst_id = form.getFieldValue(["purchase_details", index, "sgst_id"]) != undefined ? form.getFieldValue(["purchase_details", index, "sgst_id"]) : 0;
        const igst_id = form.getFieldValue(["purchase_details", index, "igst_id"]) != undefined ? form.getFieldValue(["purchase_details", index, "igst_id"]) : 0;

        const cgst_rate = form.getFieldValue(["purchase_details", index, "cgst_rate"]) != undefined ? form.getFieldValue(["purchase_details", index, "cgst_rate"]) : 0;
        const sgst_rate = form.getFieldValue(["purchase_details", index, "sgst_rate"]) != undefined ? form.getFieldValue(["purchase_details", index, "sgst_rate"]) : 0;
        const igst_rate = form.getFieldValue(["purchase_details", index, "igst_rate"]) != undefined ? form.getFieldValue(["purchase_details", index, "igst_rate"]) : 0;




        onGSTChange(index, { "type": "CGST", "value": cgst_id, "rate": cgst_rate }, index);
        onGSTChange(index, { "type": "SGST", "value": sgst_id, "rate": sgst_rate }, index);
        onGSTChange(index, { "type": "IGST", "value": igst_id, "rate": igst_rate }, index);


    }


    /**
     * onGSTChange
     * @param {*} e 
     * @param {*} v 
     * @param {*} index 
     */
    const onGSTChange = (v, e, index) => {
        
        const gst_type = e.type;
        const gst_id = e.value;
        const gst_rate = e.rate;
        
        const amount = form.getFieldValue(["purchase_details", index, "item_value",]) > 0 ? form.getFieldValue(["purchase_details", index, "item_value",]) : 0;
        let gst_amount = (amount * gst_rate) / 100;
        
        resetGst(index, gst_type , gst_id);

        if (gst_type == "CGST") {
            form.setFields([
                {
                    name: ["purchase_details", index, "cgst_amount"],
                    value: gst_amount,
                }
            ]);
            form.setFields([
                {
                    name: ["purchase_details", index, "cgst_rate"],
                    value: gst_rate,
                }
            ]);
        }
        else if (gst_type == "SGST") {
            form.setFields([
                {
                    name: ["purchase_details", index, "sgst_amount"],
                    value: gst_amount,
                }
            ]);
            form.setFields([
                {
                    name: ["purchase_details", index, "sgst_rate"],
                    value: gst_rate,
                }
            ]);
        }
        else {
            form.setFields([
                {
                    name: ["purchase_details", index, "igst_amount"],
                    value: gst_amount,
                }
            ]);
            form.setFields([
                {
                    name: ["purchase_details", index, "igst_rate"],
                    value: gst_rate,
                }
            ]);
        }


        onCalculateBlockPayable(index);
    };


    /**
     * onCalculatePayable
     * @param {*} e 
     * @param {*} v 
     * @param {*} index 
     */

    const onCalculateBlockPayable = (index) => {

        let total_amount_with_gst = 0;
        let total_gst = 0;

        const amount = form.getFieldValue(["purchase_details", index, "item_value",]) > 0 ? form.getFieldValue(["purchase_details", index, "item_value",]) : 0;
        const cgst_amount = form.getFieldValue(["purchase_details", index, "cgst_amount",]) > 0 ? form.getFieldValue(["purchase_details", index, "cgst_amount",]) : 0;
        const sgst_amount = form.getFieldValue(["purchase_details", index, "sgst_amount",]) > 0 ? form.getFieldValue(["purchase_details", index, "sgst_amount",]) : 0;
        const igst_amount = form.getFieldValue(["purchase_details", index, "igst_amount",]) > 0 ? form.getFieldValue(["purchase_details", index, "igst_amount",]) : 0;

        total_gst = parseFloat(cgst_amount) + parseFloat(sgst_amount) + parseFloat(igst_amount);
        total_amount_with_gst = total_gst + parseFloat(amount);


        form.setFields([
            {
                name: ["purchase_details", index, "item_gst_total"],
                value: total_gst.toFixed(2),
            }
        ]);

        form.setFields([
            {
                name: ["purchase_details", index, "item_total_amount"],
                value: total_amount_with_gst.toFixed(2),
            }
        ]);

        onFormCalculation();

    }


    const resetGst = (index, type , id) => {

        if (type == "IGST" && commonUtility.sanitizeValue(id) > 0) {
            form.setFields([{ name: ["purchase_details", index, "cgst_amount"], value: 0, }]);
            form.setFields([{ name: ["purchase_details", index, "cgst_rate"], value: 0, }]);
            form.setFields([{ name: ["purchase_details", index, "cgst_id"], value: "", }]);

            form.setFields([{ name: ["purchase_details", index, "sgst_amount"], value: 0, }]);
            form.setFields([{ name: ["purchase_details", index, "sgst_rate"], value: 0, }]);
            form.setFields([{ name: ["purchase_details", index, "sgst_id"], value: "", }]);
        }
        else {
            form.setFields([{ name: ["purchase_details", index, "igst_amount"], value: 0, }]);
            form.setFields([{ name: ["purchase_details", index, "igst_rate"], value: 0, }]);
            form.setFields([{ name: ["purchase_details", index, "igst_id"], value: "", }]);
        }

    }





    return (
        <div>
            <div className="form-input-style">
                <Row
                    className="login-first-step-row"
                    style={{ background: "transparent" }}
                >
                    <Col className="login-first-step-block-1" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onPurchaseSave}
                            autoComplete="off"
                            initialValues={defaultFormValues}
                            className="basicRegForm"
                            onFieldsChange={(event) => onFormCalculation()}
                            onValuesChange={(event) => onFormCalculation()}
                            onKeyUp={onFormCalculation}
                            onBlur={onFormCalculation}
                            style={{ padding: "10px 20px" }}
                        >

                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={6}>
                                    <Form.Item name="bill_number" label="Bill No" rules={[
                                        {
                                            required: true,
                                            message: 'Bill No is required',
                                        },
                                    ]}>
                                        <Input placeholder="" readOnly={false} />
                                    </Form.Item>

                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="purchase_id" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="voucher_id" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_taxable" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_cgst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_sgst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_igst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="total_gst" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>

                                    <Form.Item name="gst_including_amount" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="round_off_amount" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="round_off_account_id" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="net_amount" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="purchase_details" label="" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={6}>
                                    <Form.Item name="bill_date_picker" label="Bill Date" rules={[
                                        {
                                            required: true,
                                            message: 'Bill Date is required',
                                        },
                                    ]}>
                                        <DatePicker
                                            format="DD/MM/YYYY"
                                            // onChange={onDateOfBirthChange}
                                            onChange={onDateChange}
                                            style={{ width: "100%" }}
                                            inputReadOnly={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name="bill_date" label="Bill Dt" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>




                                <Col xs={24} xl={6}>
                                    <Form.Item name="vendor_id" label="Vendor" rules={[
                                        {
                                            required: true,
                                            message: 'Vendor is required',
                                        },
                                    ]}>
                                        {/* <Select className="text-left" defaultValue="0"> */}

                                        <Select
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                // option.children.includes(input)
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            placement="bottomLeft"

                                            allowClear={true}

                                        >
                                            {
                                                vendorList.length > 0 ?
                                                vendorList.map(vendor_data => (
                                                        <Option key={vendor_data.account_master_id} value={vendor_data.account_master_id}>{vendor_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={6}>
                                    <Form.Item name="dr_ac_id" label="Account To be Debited" rules={[
                                        {
                                            required: true,
                                            message: 'Account To be Debited is required',
                                        },
                                    ]}>
                                        {/* <Select className="text-left" defaultValue="0"> */}

                                        <Select
                                            showSearch
                                            placeholder="Search to Select"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                // option.children.includes(input)
                                                option.children.toLowerCase().includes(input.toLowerCase())
                                            }
                                            filterSort={(optionA, optionB) =>
                                                optionA.children
                                                    .toLowerCase()
                                                    .localeCompare(optionB.children.toLowerCase())
                                            }
                                            placement="bottomLeft"

                                            allowClear={true}

                                        >
                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>



                            <Row gutter={20}>
                                <Col xs={24} xl={24}>
                                    {/* <AccountDrCrDetails form={form} onDrCrCalculation={onDrCrCalculation} removeDetail={removeDetail} onDebitCreditChange={onDebitCreditChange} /> */}
                                    <PurchaseDetailView form={form} removeDetail={removeDetail} calItemAmount={calItemAmount} onGSTChange={onGSTChange} />
                                </Col>
                            </Row>

                            {
                                /**Summary */
                            }

                            <Row gutter={20}>
                                <Col xs={24} xl={24}>
                                    <Card
                                        size="small"
                                        title="Amount Summary"
                                        style={{
                                            width: 300,
                                            float: 'right',
                                            fontWeight:'500'
                                        }}
                                    >
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total Amount</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalAmount.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total CGST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalCGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total SGST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalSGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total IGST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalIGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total GST</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total GST + Amount</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.totalNetAmountWithGST.toFixed(2)}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Round Off</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.round_off_amount}</Col>
                                        </Row>
                                        <Divider dashed style={dividerStyle} />
                                        <Row gutter={20}>
                                            <Col xs={24} xl={12} >Total Net Amount (After round off)</Col>
                                            <Col xs={24} xl={12} align="right"><span>&#x20B9;</span> {summaryAmountDetails.netAmountAfterRoundOff.toFixed(2)}</Col>
                                        </Row>

                                    </Card>
                                </Col>
                            </Row>






                            <Row gutter={20}>
                                {/* <Col xs={24} xl={12} >
                                    {
                                        formErrorMessage.length > 0 ? <><Tag color="error">{formErrorMessage}</Tag></> : ''
                                    }

                                </Col> */}
                                <Col xs={24} xl={20}></Col>
                                <Col xs={24} xl={2} align="right">
                                    <Form.Item>
                                        {
                                            isSaveLoaderEnable ? <Spin /> : <>
                                                <Button htmlType="submit" className="custom-button-green" shape="round" style={{ margin: 8, border: 0 }}> Save <RightOutlined /></Button>
                                            </>
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>





                        </Form>
                    </Col>

                </Row>
            </div>


            {/* <ModalWithMessageAndAction key={commonUtility.randomID()} responseModalTitle={responseModalTitle} openModal={openModal} handleCancel={handleCancel} listLink={'/journalvoucher/list'} addmoreLink={'/journalvoucher/entry'} responseModalMessage={responseModalMessage} /> */}
            {
                responseModal.isOpenModal ? <>
                    <ModalWithMessageAndAction responseModal={responseModal} />
                </> : <></>
            }

        </div>
    )
}

export default PurchaseEntryView